module.exports = {
      id: "comm-video-usage",
      viewBox: "0 0 276.069 41.984",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-video",
      toString: function () {
        return this.url;
      }
    }